<template>
  <div class="index_header">
    <div class="homeindexHeader bgColor">
      <div class="headerBg">
        <img :src="global.imageUrl + '/headerBg.png'" alt="" />
      </div>
      <div class="headerTitle">
        <img :src="global.imageUrl + '/headerTitle.png'" alt="" />
      </div>
      <div class="topBar">
        <div class="topBar-item topBar-item-left wordColor">
          <div class="topBar-item-content" href="https://www.zyshgzb.gov.cn/" :target="target">
            <span>{{ $moment().format("YYYY-MM-DD") }}</span>
            <span style="padding-left: 10px;">{{ days[$moment().day()] }}</span>
          </div>
        </div>
        <div class="topBar-item topBar-item-right wordColor">
          <div class="topBar-item-content" href="https://www.zyshgzb.gov.cn/" :target="target">
            <span class="topBar-item-text" @click="headerItemClick(1)">设为首页</span>
          </div>
          <div class="topBar-item-content" href="https://www.zyshgzb.gov.cn/" :target="target">
            <span class=" topBar-item-text" @click="headerItemClick(2)">加入收藏</span>
          </div>
          <a class="topBar-item-content" href="/homePageApp" target="_blank">
            <span class=" topBar-item-text">手机版</span>
          </a>
          <a class="topBar-item-content pointerEvents" href="https://mail.zyshgzb.gov.cn/" target="_blank">
            <span class=" topBar-item-text">工作邮箱</span>
          </a>
        </div>
      </div>
      <div class="search">
        <div @click="searchDialogFn()" class="senior_search wordColor">高级搜索</div>
        <div class="search-input">
          <el-input clearable style="box-shadow: none" v-model="searchKey" size="small" class="w-50 m-2"
            placeholder="请输入关键字搜索" @keydown.enter="searchChange()" />
          <i class="iconfont icon-sousuo1" @click="searchChange()"></i>
        </div>
      </div>
    </div>
    <div class="navBarBox ">
      <div class="navBar_left"></div>
      <div class="navBar_center " style="padding: 0 10px;">
        <a style="color: #fff;" href="/" class="navBar_home">
          <i class="iconfont icon-home" style="font-size: 24px;"></i>
          <span style="margin-left: 4px;font-size: 20px;color: #fff;letter-spacing: 0.1em;">首页</span>
        </a>
        <div class="navBar_menu">
          <div class="menuLine">
            <a class="menuLine_item" v-for="(i, x) in $commonData.data.menuList.l1" :key="x" :href="i.value"
              :target="i.label === '委员讲堂' ? '_blank' : target">
              <span class="menuLine_item_text">{{ i.label }}</span>
            </a>
          </div>
          <div class="menuLine">
            <a class="menuLine_item" v-for="(i, x) in $commonData.data.menuList.l2" :key="x" :href="i.value"
              :target="target">
              <span class="menuLine_item_text">{{ i.label }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="navBar_center " v-if="false">
        <el-menu style="width: 100%;" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
          @select="handleSelect" background-color="rgb(248,179,128)" text-color="#bc0000" active-text-color="#f0f0f0">
          <div v-for="(i, x) in menuList" :key="x">
            <el-menu-item v-show="!i.children || !i.children.length" :index="i.value">
              <h2>{{ i.label }}</h2>
            </el-menu-item>
            <el-sub-menu v-show="i.children && i.children.length" :index="i.value">
              <template #title>
                <h2>{{ i.label }}</h2>
              </template>
              <el-menu-item v-for="(j, p) in i.children" :key="p" :index="j.value">
                <h3>{{ j.label }}</h3>
              </el-menu-item>
            </el-sub-menu>
          </div>
        </el-menu>
      </div>
      <div class="navBar_right"></div>
    </div>
    <!-- 高级搜索弹窗 -->
    <searchDialog :dialogVisible="searchDialogShow" @searchDialogClose="searchDialogShow = false"
      @clearCearch="searchKey = ''"></searchDialog>
  </div>
</template>
<script>
import global from '@/assets/js/global'
import searchDialog from '@/views/index/home/searchDialog.vue'
export default {
  name: 'home-header',
  components: {
    searchDialog
  },
  data() {
    return {
      target: '_self',
      days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      searchDialogShow: false,
      global: global,
      menuList: [
        { label: '首页', value: '/homePage' },
        {
          label: '要闻·专题',
          value: '/newList?navCode=078,jnyw,sxzt,cqzt&navName=要闻·专题'

        },
        {
          label: '部门简介', value: '/newList?navCode=bmjj&navName=部门简介',
          children: [
            { label: '本部介绍', value: '/introduce?value=bmjj_bbjs' },
            { label: '部领导', value: '/introduce?value=bmjj_bld' },
          ]
        },
        {
          label: '工作动态', value: '/newList?navCode=14&navName=工作动态',
          children: [
            { label: '基层动态', value: '/newList?navCode=014_004&navName=基层动态' },
            { label: '部门动态', value: '/bmdtMore' },
          ]
        },
        { label: '政策法规', value: '/newList?navCode=zcfg&navName=政策法规' },
        { label: '他山之石', value: '/newList?navCode=tszs&navName=他山之石' },
      ],
      searchKey: '',
      activeIndex: '',
      skinPeelerType: 'defaultColor',
    }
  },
  computed: {
  },
  mounted() {
    window.document.documentElement.setAttribute('data-theme', this.skinPeelerType)
  },
  created() {
  },
  methods: {
    handleSelect(e) {
      console.log(e)
      if (!e) { return }
      if (e === '/homePage') {
        this.$router.push(e)
      } else {
        window.open(e, '_black')
      }
      // if (e.indexOf('http://') > -1 || e.indexOf('https://') > -1) {
      //   window.open(e, '_black')
      // } else {
      //   this.$router.push(e)
      // }
    },
    headerItemClick(e) {
      switch (e) {
        case 1:
          alert('您的浏览器不支持自动设置页面为首页功能，请您手动在浏览器里设置该页面为首页！')
          break;
        case 2:
          alert('您的浏览器不支持自动添加收藏功能，请使用Ctrl+D进行添加，或者手动在浏览器里设置！')
          break;
        default:
          break;
      }
    },
    searchDialogFn() {
      this.searchDialogShow = true
    },
    searchChange() {
      this.$router.push({
        path: '/search',
        query: {
          searchKey: this.searchKey || '',
          searchType: 1,
          time: new Date().getTime()
        }
      })

    },

  }
}
</script>
<style lang="scss">
$boxwidth: 1200px;

.index_header {
  .homeindexHeader {
    position: relative;
    background-size: 100% 100%;
    min-width: $boxwidth;
    height: 290px;

    .headerBg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      z-index: 1;
      top: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .headerTitle {
      position: relative;
      z-index: 5;
      width: $boxwidth;
      margin: auto;
      padding-left: 0px;
      display: flex;
      align-items: center;
      height: 100%;
      padding-top: 16px;

      img {
        height: calc(47% + 16px);
      }
    }

    .topBar {
      padding: 8px 12px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 10;

      .topBar-item {
        display: flex;
        align-items: center;
        padding-right: 10px;
        font-size: 14px;

        .topBar-item-content {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #fff;

          .topBar-item-text {
            cursor: pointer;

            &:hover {
              opacity: 0.7;
            }
          }
        }
      }

      .topBar-item-left {
        .topBar-item-content {
          margin-right: 15px;
        }
      }

      .topBar-item-right {
        .topBar-item-content {
          margin-left: 15px;
        }
      }
    }

    .search {
      position: absolute;
      bottom: 10px;
      right: 30px;
      display: flex;
      align-items: center;

      .senior_search {
        font-size: 14px;
        padding-right: 10px;
        color: #f9f9f9;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }

      .search-input {
        border-radius: 20px;
        box-shadow: 0px 0px 1px 1px rgb(208, 207, 207) inset;
        padding: 3px 10px;
        background: #fff;
        display: flex;
        align-items: center;
        width: 250px;
        height: 32px;

        i {
          font-size: 18px;
          color: #ccc;
          cursor: pointer;
        }

        .el-input__wrapper {
          box-shadow: none;
          font-size: 14px;
        }
      }

      .search-key {
        padding-top: 5px;

        span {
          font-size: 14px;
          color: #717070;
          cursor: pointer;
        }

        .s-k:hover {
          opacity: 0.6;
        }

        .line {
          padding: 5px;
        }
      }
    }

  }

  .navBarBox {
    display: flex;
    height: 100px;
    // background: rgb(248, 179, 128);

    .el-menu-demo {
      width: 1200px;
      margin: 0 auto;
      justify-content: space-between;
      border: none;

      .el-menu-item {
        height: 100%;
      }
    }

    .navBar_left {
      background: url("../../assets/img/headerLeftNew.png") top center no-repeat;
      background-size: 100% 100%;
      width: calc((100% - 1200px) / 2);
    }

    .navBar_right {
      background: url("../../assets/img/headerRightNew.png") top center no-repeat;
      background-size: 100% 100%;
      width: calc((100% - 1200px) / 2);
    }

    .navBar_center {
      width: $boxwidth;
      height: 100%;
      margin: auto;
      background: url("../../assets/img/headerCenterNew.png") top center no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .navBar_home {
        width: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 18px;
        background: #ffffff40;
        border-radius: 50px;
        padding: 10px 0;
        cursor: pointer;
      }

      .navBar_home:hover {
        background: #ffffff80;
      }

      .navBar_menu {
        width: calc(100% - 150px);

        .menuLine {
          width: calc(100% - 40px);
          padding: 5px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 20px;

          .menuLine_item {

            .menuLine_item_text {
              letter-spacing: 0.1em;
              color: #fff;
              cursor: pointer;
            }

            .menuLine_item_text:hover {
              opacity: 0.8;
            }
          }

          // .menuLine_item:nth-child(1) {
          //   width: 180px;
          // }

          // .menuLine_item:nth-child(2) {
          //   width: 310px;
          // }

          // .menuLine_item:nth-child(3) {
          //   width: 250px;
          // }

          // .menuLine_item:nth-child(4) {
          //   width: 150px;
          // }


        }
      }
    }
  }

}
</style>
